
import React from 'react'
import { Controller } from 'react-hook-form'
import { getLanguage } from 'react-multi-lang'
import Select from 'react-select'

export default function ASelect({ v, onChange }) {


    const getSelectStatus = () => v.data.name === 'invoice_type' || v.data.name === 'tariff_type' || v.data.name === 'from' || v.data.name === 'invoice_tariff'
        || v.data.name === 'letter_tariff' || (v.data.name === 'company' && v.data.model !== 'tariff')
    const handleOnChange = (e) => {
        if (getSelectStatus())
            onChange(e)
    }


    return (
        <>
            {!v.data.hide && <div className={`flex flex-col min-w-[200px] ${v.data?.className}`}>
                {!v.data?.isStyle && <p className="text-base text-black  font-bold amiriB">{v.data?.label} {v.data?.required&& <span className='text-red-700'>*</span>} </p>}
                <Controller
                    control={v.control}
                    rules={{ required: v.data.required }}
                    error={v.data.required}
                    name={v.data.name}
                    render={({
                        field: { onChange, onBlur, value, name, ref },
                    }) => (
                        <Select

                            options={v.data.options}
                            onChange={getSelectStatus() ? handleOnChange : onChange}
                            menuPortalTarget={v.type === "search" ? document.body : ref.current}
                            menuPosition={'fixed'}
                            onBlur={onBlur}
                            value={value}
                            name={name}
                            ref={ref}
                            isDisabled={v.data?.isDisabled}
                            isMulti={v.data?.isMulti}
                            isClearable={true}
                            placeholder={getLanguage() === 'en' ? 'Select' : 'انتخاب کنيد'}
                            theme={theme => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: 'white',
                                    primary: v.errors[v.data?.name] ? 'red' : 'purple',


                                },


                            })}
                            styles={{
                                option: (base) => ({
                                    ...base,
                                    borderBottom: `1px solid gray`,
                                    height: '100%',
                                }),
                            }}
                        />

                    )}

                /> {v.errors[v.data?.name] && v.data.required && <small className="text-red-600">{v.data.required}</small>}
            </div>}
        </>
    )
}
